import React, { useState } from 'react';
import '../css/LogInAdmin.css';
import firebase from '../config/Firebase';
import { useHistory } from 'react-router-dom';
import Logo from '../assets/imgs/default.png';
import IconEmail from '../assets/imgs/email_icon.svg';
import IconPass from '../assets/imgs/pass_icon.svg';
import IconShowPass from '../assets/imgs/show_pass_icon.svg';
// import axios from 'axios';
// import { similarity } from '../utils/similarity';
// import { updateReviewAttractions } from '../apis/attractions.endpoint';

function LogInAdmin() {
  const [email, setEmail] = useState('');
  const [password, setPass] = useState('');
  const [docs, setDocs] = useState();
  const [newAttractions, setNewAttractions] = useState();
  const history = useHistory();

  async function handleLogLogin(data) {
    const date = new Date();
    const dataString = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    
    const log = {
      cidade: data.data().city,
      data: date,
      dataString: dataString,
      email: data.data().email,
      nome: data.data().name,
      role: data.data().role,
      userId: data.id,
    };

    await firebase.firestore().collection('LogLogin').add(log);
  }

  const loginAdm = () => {
    if (email === '') {
      alert('digite seu email');
    } else if (password === '') {
      alert('digite sua senha');
    } else {
      firebase.auth().signInWithEmailAndPassword(email, password).then(async (user) => {
        const stateQueryRes = await firebase.firestore().collection('users').doc(user.user.uid).get();
        const role = stateQueryRes.data().role;

        const rolesPermission = ['admin', 'masterAdmin', 'cityAdmin', 'contentManager', 'tradeAdmin', 'dashboardViewer', 'contentEditor', 'regionAdmin', 'rotaAdmin'];
        if (rolesPermission.includes(role)) {
          handleLogLogin(stateQueryRes);
          history.push('/admin/dashboards');
        } else {
          firebase.auth().signOut().then(() => {
            alert('Usuario sem permissão!');
          });
        }
      }).catch((error) => {
        // Email ou senha errados
        if (error.code === 'auth/invalid-email') {
          alert('Email incorreto!');
          document.getElementById('email_adm').value = '';
          document.getElementById('email_adm').focus();
        } else if (error.code === 'auth/wrong-password') {
          alert('Senha incorreta!');
          document.getElementById('password_login_adm').value = '';
          document.getElementById('password_login_adm').focus();
        } else if (error.code === 'auth/user-not-found') { // Email não cadastrado
          alert('Usuario não encontrado!');
          document.getElementById('email_adm').value = '';
          document.getElementById('email_adm').focus();
        }
      });
    }
  };

  function showPassword() {
    const pass = document.getElementById('password_login_adm');
    if (pass.type === 'text') 
      pass.type = 'password';
    else
      pass.type = 'text';
  }

  const forgotPass = () => {
    if (email !== '') {
      firebase.auth().sendPasswordResetEmail(email).then(() => {
        alert('link de redefinição enviado para o email!');
      }).catch((error) => {
        alert('Ocorreu um erro!');
      });
    } else {
      alert('digite algum email no campo para redefinir a senha');
    }
  };

  const handleKey = (e) => {
    if (e.key === 'Enter')
      document.getElementById('btn_login_adm').click();
  };

  // const getAttractions = async () => {
  //   const lastDoc = await firebase.firestore().collection("Attractions").doc("JF8aKspMSnHNVNOijejl").get();
  //   console.log(lastDoc.data());
  //   const docs = await firebase.firestore().collection("Attractions")
  //     .where("Type", "in", ["Attraction", "Food", "Lodging"])
  //     .startAfter(lastDoc)
  //     .get();

  //   setDocs(docs);
  //   console.log("Atrativos pegos!");
  //   console.log(docs.docs.length);
  //   console.log(docs.docs[0].id);
  // }

  // const saveAttractions = async () => {
  //   const savedAttractions = [];
  //   for (let i = 0; i < newAttractions.length; i++) {
  //     const data = newAttractions[i];
  //     const id = data.id;

  //     delete data.id;
  //     delete data.Title;
  //     delete data["Short Description"];
  //     delete data["Long Description"];
  //     delete data.City;
  //     delete data.Type;
  //     delete data.Subtype;
  //     delete data.Especialidade;
  //     delete data.Visible;
  //     delete data.Active;
  //     delete data.cidadeAtiva;
  //     delete data.UtilidadePublica;
  //     delete data.location;
  //     delete data.acessPoint;
  //     delete data.types;
  //     delete data.Endereço;
  //     delete data.Telefone;
  //     delete data.Email;
  //     delete data.emailAdmin;
  //     delete data.Whatsapp;
  //     delete data.Video;
  //     delete data.Website;
  //     delete data.Instagram;
  //     delete data.Facebook;
  //     delete data["Horário de Funcionamento"];
  //     delete data["Meios de Pagamento"];
  //     delete data["Segmento Turístico"];
  //     delete data["Aceita Cartões"];
  //     delete data["Aceita Animais"];
  //     delete data.Acessibilidade;
  //     delete data["Capacidade Individual"];
  //     delete data.Cadastur;
  //     delete data.UHs;
  //     delete data["Atendimento Idioma Estrangeiro"];
  //     delete data["Número de Funcionários Fixos"];
  //     delete data["Número de Funcionários Temporários"];
  //     delete data["Decoração diferenciada ou temática"];
  //     delete data.destaqueLocal;
  //     delete data.cnpj;
  //     delete data.imageFile;
  //     delete data.classificadoAtrativo;
  //     delete data.justifiqueAtrativo;
  //     delete data.Valor;
  //     delete data.FaixaEtaria;
  //     delete data["Activities List"];
  //     delete data.TipoPublico;
  //     delete data.Impulsionar;
  //     delete data.lgbt;
  //     delete data.tombadoCondephaat;
  //     delete data.tombadoIPHAN;
  //     delete data.tombamentoMunicipal;
  //     delete data.centroHistoricoTombado;
  //     delete data.fotoCapa;
  //     delete data.imagefileURL;
  //     delete data.Tripadvisor_Nota;
  //     delete data.Tripadvisor_QuantidadeAvaliacoes;
  //     delete data.Roteiros;
  //     delete data.Imperdivel;
  //     delete data.traduzido;
  //     delete data.Tripadvisor_Award;
  //     delete data.nomeRegiao;
  //     delete data.original;
  //     delete data.imagefile;
  //     delete data.Estado;
  //     delete data.Sigla;
  //     delete data.access;
  //     delete data.numeroAbertura;

  //     if (Object.keys(data).length > 0) {
  //       await firebase.firestore().collection("Attractions").doc(id).update({
  //         ...data
  //       });
  //       console.log(data);
  //       console.log(`Progresso ${i}/${newAttractions.length} - ID: ${id}`);
  //       savedAttractions.push(id);
  //     }
  //   }

  //   console.log(savedAttractions);
  //   console.log("Done");
  // }

  // const updateReviewAttractions = async () => {
  //   const googleApiKey = 'AIzaSyDd3qwHtsqLlv_0GuVzOOrtZ6-XvZRifEc';
  //   const tripAdvisorKey = '9CC1AC9B7EBE43FDA7A8CD459A296479';
  //   const docsToSave = [];
  //   let i = 0;
  //   for (const doc of docs.docs) {
  //     console.log(`Progresso ${i}/${docs.docs.length} - ID: ${doc.id}`);
  //     i++;
  //     try {
  //       const data = doc.data();
  //       const { Title: titulo, location, City: cidade } = data;
  //       const { latitude, longitude } = location;

  //       const gmapsUrl = `https://maps.googleapis.com/maps/api/place/nearbysearch/json?radius=100&name=${titulo}&location=${latitude},${longitude}&key=${googleApiKey}`;
  //       const tripUrl = `https://api.content.tripadvisor.com/api/v1/location/search?key=${tripAdvisorKey}&searchQuery=${titulo}&latLong=${latitude},${longitude}&radius=100&radiusUnit=m&language=pt`;

  //       const [response, secondResponse] = await Promise
  //         .all([axios(gmapsUrl), axios(tripUrl)]);
  //       const jsonData = response.data;
  //       const secondJsonData = secondResponse.data;

  //       let filteredValue = { ...data };

  //       const firstResult = jsonData.results?.[0];
  //       if (firstResult) {
  //         filteredValue = {
  //           ...filteredValue,
  //           Nota: firstResult.rating || null,
  //           QuantidadeAvaliacoes: firstResult.user_ratings_total || null,
  //           FaixaPreco: firstResult.price_level || null,
  //           PlaceId: firstResult.place_id || null,
  //         };
  //       }

  //       const secondResult = secondJsonData.data?.[0];
  //       if (
  //         secondResult &&
  //         parseFloat(secondResult.distance) * 100 < 10 &&
  //         secondResult.address_obj.city === cidade &&
  //         similarity(titulo, secondResult.name) >= 0.75
  //       ) {
  //         const location_id = secondResult.location_id;
  //         const detailsUrl = `https://api.content.tripadvisor.com/api/v1/location/${location_id}/details?key=${tripAdvisorKey}&language=pt&currency=BRL`;

  //         const { data: resultDetalhes } = await axios.get(detailsUrl);

  //         const mapaResultados = {
  //           PossuiTripadvisor: true,
  //           Tripadvisor_location_id: location_id,
  //           Tripadvisor_Nota: parseFloat(resultDetalhes.rating || "0"),
  //           Tripadvisor_QuantidadeAvaliacoes: parseInt(resultDetalhes.num_reviews || "0"),
  //           Tripadvisor_Ranking: resultDetalhes.ranking_data?.ranking_string || "",
  //           Tripadvisor_FaixaPreco: resultDetalhes.price_level || "",
  //           Tripadvisor_UrlFotos: resultDetalhes.see_all_photos || "",
  //           Tripadvisor_LongDescr: resultDetalhes.description || "",
  //           Tripadvisor_AvaliacoesPorNota: Object.fromEntries(
  //             Object.entries(resultDetalhes.review_rating_count || {}).map(
  //               ([k, v]) => [k, parseInt(v)]
  //             )
  //           ),
  //           Tripadvisor_NotaPorTipo: Object.fromEntries(
  //             Object.values(resultDetalhes.subratings || {}).map((r) => [r.localized_name, parseFloat(r.value)])
  //           ),
  //           Tripadvisor_TipoPublico: Object.fromEntries(
  //             (resultDetalhes.trip_types || []).map((tp) => [tp.localized_name, parseInt(tp.value)])
  //           ),
  //         };

  //         if (resultDetalhes.awards?.length > 0) {
  //           const award = resultDetalhes.awards[0];
  //           mapaResultados["Tripadvisor_Award"] = {
  //             tipo: award.award_type,
  //             ano: award.year,
  //             img: award.images.large,
  //             display: award.display_name,
  //           };
  //         }

  //         if (resultDetalhes.amenities?.length > 0) {
  //           mapaResultados["Tripadvisor_Amenities"] = resultDetalhes.amenities;
  //           mapaResultados["Activities List"] = resultDetalhes.amenities;
  //         }

  //         filteredValue = {
  //           ...filteredValue,
  //           ...mapaResultados,
  //         };

  //       }
        
  //       console.log(filteredValue);
  //       docsToSave.push({ ...filteredValue, id: doc.id });
  //     } catch (e) {
  //       console.error(`Failed to update review of doc ${doc.id}:`, e);
  //     }
  //   }

  //   setNewAttractions(docsToSave);
  //   console.log("Done");
  // }

  // const getRegionsOfAllRoutes = async () => {
  //   const res = await firebase.firestore().collection("Roteiros").get();
  //   const docs = res.docs;
    
  //   console.log(docs.length);

  //   for (let i = 0; i < docs.length; i++) {
  //     const doc = docs[i];

  //     const resFetch = await firebase.firestore().collection("Cities").where("name", "==", doc.data().City).get();
  //     const cityDoc = resFetch.docs[0];
  //     const cityData = cityDoc.data();

  //     if (cityData && cityData.nomeRegiao) {
  //       console.log(`ID: ${doc.id} | Região (docCity): ${cityData.nomeRegiao} | Região (rota) ${doc.data().nomeRegiao || "Não tem"}`);
  //       await firebase.firestore().collection("Roteiros").doc(doc.id).update({
  //         nomeRegiao: cityData.nomeRegiao
  //       });
  //     }
  //   }
  // }

  return (
    <div className="loginAdm">
      <section className="top_navbar">
        <div className="div_elements_nav">
          <img src={Logo} className="icon_destinos" alt="Icone de um flamingo"/>
        </div>
        <div className="div_elements_nav">
          <h3 className="title_nav">Destinos Inteligentes</h3>
        </div>
      </section>
      <section className="content_login">
        <img src={Logo} className="icon_destinos" alt="Icone de um flamingo"/>
        <h3 className="title_form">PAINEL DE GESTÃO</h3>
        {/*<button onClick={() => getAttractions()}>Pegar atrativos</button>
        <button onClick={() => updateReviewAttractions()}>Pegar os dados</button>
        <button onClick={() => saveAttractions()}>Salvar os dados</button>
        <button onClick={() => getRegionsOfAllRoutes()}>Pegar regiões de cada rota</button>*/}
        <form className="form_login">
          <div className="body_form">
            <div className="div_input_form">
              <img src={IconEmail} class="icon_email_form" alt="Icone de email" />
              <input type="text" name="email" placeholder="Email" className="field_login" onChange={(event) => setEmail(event.target.value)} id="email_adm" onKeyPress={(key) => handleKey(key)} />
            </div>
            <div className="div_input_form">
              <img src={IconPass} class="icon_pass_form" alt="Icone de senha" />
              <input type="password" placeholder="Password" className="field_login" onChange={(event) => setPass(event.target.value)} id="password_login_adm" onKeyPress={(key) => handleKey(key)} />
              <img src={IconShowPass} class="icon_show_pass" alt="Icone de senha" onClick={() => showPassword()}/>
            </div>
            <div className="div_forgot_password_admin">
              <p class="forgot_password_admin" onClick={() => forgotPass()}>Esqueceu a senha?</p>
            </div>
            <button type="button" id="btn_login_adm" className="btn_login_adm" onClick={() => loginAdm()}>Login com Email</button>
          </div>
        </form>
      </section>
    </div>
  );
}

export default LogInAdmin;